<template>
  <div>
    <span id="topo"></span>

    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn text rounded color="primary" :to="{name: 'EstoqueLista'}" exact :disabled="salvando">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      <!-- </v-toolbar-items> -->
      <!-- <v-spacer></v-spacer> -->

      <template v-slot:actions>
        <!-- <v-btn text @click="$router.push({name: 'EstoqueLista'})" :disabled="salvando">Cancelar</v-btn> -->
        <!-- <v-btn text @click="gerarParcelas">Gerar Parcelas</v-btn> -->
        
        <template v-if="isAdicionando">
          <v-btn 
            v-if="isAdicionando"
            outlined
            rounded
            color="primary" 
            class="text-none"
            :loading="salvando" 
            :disabled="!form_valido || !movimento.fornecedor_id"
            @click="abrirPedidosCompra"
          >
            <v-icon left>mdi-download-outline</v-icon>
            Carregar Pedido de Compra
          </v-btn>
          <v-divider vertical class="px-2"></v-divider>
        </template>
        <v-btn
          text
          rounded
          :disabled="salvando"
          @click="$router.push({name: 'EstoqueLista'})"
        >Cancelar</v-btn>
        <v-btn 
          v-if="isAdicionando || config.ALTERAR_MOVIMENTO_ESTOQUE"
          depressed
          rounded
          color="primary" 
          :loading="salvando" 
          :disabled="!form_valido"
          @click="confirmar" 
        >Salvar</v-btn>
  
        <v-btn
          v-if="isTransferencia"
          depressed
          rounded
          color="primary"
          :loading="salvando"
          @click="transferir"
        >Transferir</v-btn>
      </template>
    </z-centralized-toolbar>


    <v-form ref="form" v-model="form_valido" lazy-validation>
      <z-container>

        <v-tabs v-model="tab" background-color="transparent" color="primary">
          <v-tab>Movimento de Estoque</v-tab>
          <v-tab v-show="exibirContasPagar">
            Contas a Pagar 
            <v-badge v-show="movimento.contaspagar && movimento.contaspagar.length > 0" inline color="primary" class="ml-1" :content="movimento.contaspagar.length"></v-badge>
          </v-tab>
        </v-tabs>
        <v-divider class="mb-2"></v-divider>

        <v-tabs-items v-model="tab" class="transparent pa-1">
          <v-tab-item v-bind="$v.TABS_CONFIG">
            <h3 class="text-headline mb-3" v-if="isTransferencia">Loja de Origem: {{ movimento.loja.abreviacao }}</h3>
      
            <v-card class="mb-3" :disabled="isTransferencia">
              <v-toolbar flat color="white" dense>
                <h3 class="text-subtitle-2">Movimento de Estoque</h3>
              </v-toolbar>
              <v-divider></v-divider>
      
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" sm="2">
                    <v-text-field
                      v-model="movimento.id"
                      dense
                      label="Número"
                      disabled
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <!-- <v-text-field label="Data" v-model="movimento.data" append-icon="event"></v-text-field> -->
                    <z-date-picker-menu
                      v-model="movimento.data"
                      dense
                      label="Data"
                      :rules="regras.obrigatorio"
                      filled
                      :readonly="!isAdicionando"
                    ></z-date-picker-menu>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-select
                      v-model="movimento.movimento"
                      dense
                      label="Movimento"
                      filled
                      :items="['Entrada', 'Saída']"
                      :readonly="!isAdicionando"
                      :disabled="produtos.length > 0"
                      @change="onMovimentoChange"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="4" v-if="isEntrada">
                    <v-autocomplete
                      v-model="movimento.fornecedor_id"
                      dense
                      label="Fornecedor"
                      filled
                      rules_="regras.obrigatorio"
                      :clearable="isAdicionando"
                      :readonly="!isAdicionando"
                      :disabled="isPedidoCompra"
                      :items="$store.getters['listas/fornecedores']"
                    ></v-autocomplete>
                  </v-col>
                  
                  <v-col cols="12" sm="2" v-if="isEntrada">
                    <v-text-field
                      v-model="movimento.lote"
                      dense
                      label="Lote"
                      filled
                      :readonly="!isAdicionando"
                    ></v-text-field>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="6"
                    v-if="!isEntrada && lojas.length > 1 && config.USAR_SISTEMA_MULTI_LOJAS == true"
                  >
                    <v-autocomplete
                      v-model="movimento.loja_id_destino"
                      label="Loja Destino"
                      dense
                      clearable
                      filled
                      hint="Informar somente em caso de transferênica"
                      persistent-hint
                      :items="lojas"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
      
            <adicionar-produto 
              v-if="exibirAdicionarProduto"
              class="mb-3 sticky" 
              ref="adicionarProduto"
              movimento-estoque
              somar-produtos
              permitir-produtos-duplicados
              tela="movimento_estoque"
              :somente-quantidade="!isEntrada"
              :produtos="movimento.produtos"
              :total="movimento.valor_total"
              @adicionar_="adicionarProduto"
            ></adicionar-produto>
            
            <v-card class="mb-3">
              <v-toolbar flat color="white" dense>
                <h3 class="text-subtitle-2">Produtos</h3>
                <v-spacer></v-spacer>
                <span class="mr-5">Itens: {{ movimento.produtos.length }}</span>
                <span class="mr-5">Valor Total: {{ movimento.valor_total | valorBR }}</span>
              </v-toolbar>
              
              <v-divider></v-divider>
              
              <template v-if="config.USAR_ADICIONAR_PRODUTO_MODAL && (isAdicionando || config.ALTERAR_MOVIMENTO_ESTOQUE)">
                <v-toolbar flat color="white" dense>
                  <v-btn color="primary" depressed @click="$refs.adicionarProdutoModal.abrir()">Adicionar Produto</v-btn>
                </v-toolbar>
                <v-divider></v-divider>
              </template>

      
              <v-data-table
                hide-default-footer
                disable-pagination
                item-key="id"
                :headers="isEntrada ? headers_entrada : headers_saida"
                :items="movimento.produtos"
                :loading="false"
              >
                <template v-slot:item="{item: produto, index}">
                  <tr>
                    <td>{{ index + 1 }}</td>
                    <td>{{ produto.referencia }}</td>
                    <td>
                      <div>{{ produto.descricao }}</div>
                      <template v-if="produto.produto?.produto_grupo_id">
                        <v-chip
                          class="mr-2"
                          x-small
                          color="grey lighten-2"
                        >{{produto.produto.grupo.descricao}}</v-chip>
                      </template>
                      <template v-if="produto.grade">
                        <v-chip
                          v-for="(_grade, index) in produto.grade"
                          class="mr-2"
                          x-small 
                          color="grey lighten-2"
                          :key="index"
                        >{{_grade.descricao}}</v-chip>
                      </template>
                    </td>
                    <td class="text-right d-flex justify-end align-center">
                      <span v-if="!isTransferencia && !isPedidoCompra">{{ produto.quantidade | valorQTD(config.CASAS_DECIMAIS_QUANTIDADE) }} {{ produto.unidade }}</span>
                      <z-campo-valor
                        style="max-width: 150px"
                        v-if="isTransferencia || isPedidoCompra"
                        v-model="produto.quantidade" 
                        dense 
                        outlined 
                        single-line 
                        hide-details 
                        decimais="0"
                        :suffix="produto.unidade"
                        @input="produto.subtotal = produto.valor_custo * produto.quantidade"
                      ></z-campo-valor>
                    </td>
                    <template v-if="isEntrada">
                      <td class="text-right">{{ produto.valor_custo | valorBR }}</td>
                      <td class="text-right">{{ produto.subtotal | valorBR }}</td>
                    </template>
                    <td class="text-center">
                      <v-btn icon @click="excluirProduto(produto)" v-if="!isTransferencia && !isVisualizando" tabindex="-1" >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template v-slot:body.append="{ headers }" v-if="produtos.length > 0">
                  <tr>
                    <td class="text-right" colspan="4">
                      <b>{{ movimento.quantidade_total | valorQTD(config.CASAS_DECIMAIS_QUANTIDADE) }}</b>
                    </td>
                    <td class="text-right" colspan="2" v-if="isEntrada">
                      <b>{{ movimento.valor_total | valorBR }}</b>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
      
            <v-card class="mb-3">
              <v-toolbar flat color="white" dense>
                <h3 class="text-subtitle-2">Totais</h3>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-col sm="10">
                    <v-row>
                      <v-col sm="12">
                        <v-textarea filled
                          v-model="movimento.observacoes"
                          label="Observações"
                          rows="6"
                          :readonly="isTransferencia"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col sm="2">
                    <v-row dense>
                      <v-col sm="12" v-if="isEntrada">
                        <z-campo-valor
                          v-if="isEntrada"
                          decimais="0"
                          label="Itens"
                          v-model="movimento.itens"
                          readonly
                          filled
                          dense
                          hide-details
                        ></z-campo-valor>
                      </v-col>
                      <v-col sm="12">
                        <z-campo-valor
                          label="Quantidade"
                          v-model="movimento.quantidade_total"
                          readonly
                          filled
                          dense
                          hide-details
                        ></z-campo-valor>
                      </v-col>
                      <v-col sm="12" v-if="isEntrada">
                        <z-campo-valor
                          label="Valor Total"
                          v-model="movimento.valor_total"
                          readonly
                          filled
                          dense
                          hide-details
                        ></z-campo-valor>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
      
            </v-card>
          </v-tab-item>

          <v-tab-item v-bind="$v.TABS_CONFIG" eager>
            <TabContasPagar ref="tabContasPagar"></TabContasPagar>
          </v-tab-item>
        </v-tabs-items>
        
      </z-container>
    </v-form>
    <!-- <busca-produto
      ref="buscaproduto"
      @selecionar:produto="selecionarProduto"
    ></busca-produto> -->

    <dialogo-buscar-produto ref="buscaproduto" @selecionar:produto="selecionarProduto"></dialogo-buscar-produto>

    <z-dialogo-sim-nao
      ref="dialogoRemoverItem"
      titulo="Remover item?"
      botaoSim="Remover"
      botaoNao="Não Remover"
    >
      O item será removido do movimento. Deseja remover?
    </z-dialogo-sim-nao>

    <dialogo-exibir-entradas ref="dialogoExibirEntradas"></dialogo-exibir-entradas>

    <adicionar-produto-modal 
      ref="adicionarProdutoModal"
      movimento-estoque
      somar-produtos
      permitir-produtos-duplicados
      tela="movimento_estoque"
      :produtos="movimento.produtos"
      :total="movimento.valor_total"
    ></adicionar-produto-modal>

    <DialogoPedidosCompra ref="dialogoPedidosCompra" @confirmar="carregarPedidoCompra"></DialogoPedidosCompra>

  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from "vuex";
import BuscaProduto from "@/pages/pedidos/BuscaProduto";
import DialogoBuscarProduto from "@/pages/pedidos/DialogoBuscarProduto";
import DialogoExibirEntradas from "@/pages/produtos/DialogoExibirEntradas";
import AdicionarProduto from "@/pages/produtos/AdicionarProduto";
import AdicionarProdutoModal from "@/pages/produtos/AdicionarProdutoModal";
import DialogoPedidosCompra from "./DialogoPedidosCompra.vue";
import TabContasPagar from "./TabContasPagar.vue";

export default {
  name: "EstoqueForm",

  components: {
    BuscaProduto,
    DialogoBuscarProduto,
    DialogoExibirEntradas,
    AdicionarProduto,
    AdicionarProdutoModal,
    DialogoPedidosCompra,
    TabContasPagar,
  },

  data() {
    return {
      // movimento: {
      //   fornecedor_id: "",
      //   loja_id_destino: "",
      //   pedidocompra_id: null,
      //   data: "",
      //   movimento: "Entrada",
      //   itens: 0,
      //   quantidade_total: 0,
      //   valor_total: 0,
      //   observacoes: "",
      // },
      produtos: [],
      produto: {
        referencia: null,
        descricao: null,
        unidade: null,
        quantidade: 0,
        valor: 0,
        subtotal: 0,
      },
      salvando: false,
      buscando: false,
      estornando: false,
      form_valido: false,
      regras: {
        obrigatorio: [(v) => !!v || "Campo obrigatório"],
      },
      tab: 0,
      headers_entrada: [
        {text: "Item", value: "", width: "80px", sortable: false},
        {text: "Referência", value: "referencia", width: "200px", sortable: false,},
        {text: "Descrição", value: "descricao", sortable: false },
        {text: "Quantidade", value: "quantidade", align: "right", sortable: false,},
        {text: "Valor Custo", value: "valor_custo", align: "right", sortable: false },
        {text: "SubTotal", value: "subtotal", align: "right", sortable: false,},
        {text: "Opções", value: "", width: "200px", align: "center", sortable: false,},
      ],
      headers_saida: [
        {text: "Item", value: "",width: "80px", sortable: false},
        {text: "Referência", value: "referencia", width: "200px", sortable: false,},
        {text: "Descrição", value: "descricao", sortable: false },
        {text: "Quantidade", value: "quantidade", align: "right", sortable: false,},
        {text: "Opções", value: "", width: "200px", align: "center", sortable: false,},
      ],
      loading: false,
      drawerProdutos: false,
      buscarproduto: "",
      produtosBusca: [],
      exibirMensagem: false,
      hidedetails: true,
      exibindoEntradas: false,
    };
  },

  computed: {
    ...mapGetters("listas", ["lojas"]),
    ...mapState("lojas", ["loja_atual"]),
    ...mapState('movimentoestoque', ['movimento']),

    labelQuantidade() {
      return this.produto.unidade ? "Quantidade (" + this.produto.unidade + ")" : "Quantidade";
    },

    isEntrada() {
      return this.movimento.movimento == "Entrada";
    },

    config() {
      return this.$store.state.configuracoes;
    },

    titulo() {
      let titulo = "";

      if (this.isTransferencia) {
        return "Transferência";
      }

      if (this.$route.name == "EstoqueAdicionar") {
        titulo = "Adicionar";
      }

      if (this.$route.name == "EstoqueEditar") {
        titulo = "Editar";
      }

      if (this.$route.name == "EstoqueVisualizar") {
        titulo = "Visualizar";
      }

      return titulo + " " + "Movimento";
    },

    isAdicionando() {
      return this.$route.name == "EstoqueAdicionar";
    },

    isVisualizando() {
      return this.$route.name == "EstoqueVisualizar";
    },

    isTransferencia() {
      if (this.$route.name == 'EstoqueEditar') {
        return this.movimento.id && this.movimento.loja_id_destino && this.movimento.loja_id != this.loja_atual.id;
      }

      return false;
    },

    isPedidoCompra() {
      return this.movimento.pedidocompra_id != null;
    },

    exibirAdicionarProduto() {

      if (this.isPedidoCompra || this.isVisualizando || this.config.USAR_ADICIONAR_PRODUTO_MODAL == true) {
        return false;
      }

      return this.isAdicionando || this.isTransferencia || this.config.ALTERAR_MOVIMENTO_ESTOQUE;
    },

    exibirContasPagar() {
      return this.isEntrada && this.movimento.valor_total > 0 && !!this.movimento.fornecedor_id; //this.config.USAR_CONTAS_PAGAR;
    },

    currentTab() {
      return this.$route.query.tab == "contas" ? 1 : 0;
    },
  },

  beforeRouteLeave(to, from, next) {
    this.UNSET_MOVIMENTO();
    next();
  },

  async mounted() {

    this.$store.dispatch("listas/fornecedores");
    this.$store.dispatch("listas/lojas");

    if (["EstoqueEditar", "EstoqueVisualizar"].includes(this.$route.name) && this.$route.params.id) {

          try {
            await this.abrir(this.$route.params.id);
          } catch (error) {
            this.$eventbus.erro("Não foi possível abrir este movimento.", error);
            this.LOADING_OFF();
          }



      if (this.isTransferencia) {
        this.movimento.movimento = 'Entrada'
      }

      if (this.exibirContasPagar) {
        this.tab = this.$route.query.tab == "contas" ? 1 : 0;
      }

    } else {
      this.movimento.data = this.hoje();
    }

    this.setTitulo(this.titulo);
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapMutations("movimentoestoque", ["UNSET_MOVIMENTO"]),
    ...mapActions("movimentoestoque", ["abrir", "atualizar", "salvar"]),

    async confirmar() {
      if (this.$refs.form.validate()) {
        if (this.movimento.produtos.length == 0) {
          this.$eventbus.notificar("O movimento está vazio. É necessário adicionar itens ao movimento.");
          return;
        }

        try {
          this.salvando = true;

          delete this.movimento.loja;
          delete this.movimento.loja_destino;

          if (this.$route.params.id) {
            await this.atualizar(this.movimento);
          } else {
            this.gerarParcelas();
            await this.salvar(this.movimento);
          }

          this.$eventbus.notificar("Movimento salvo com sucesso.");
          this.$router.push({ name: "EstoqueLista" });
        } catch (error) {
          this.$eventbus.erro("Não foi possível salvar este movimento. Verifique os dados do pedido e tente novamente.", error);
        } finally {
          this.salvando = false;
        }
      }
    },

    async transferir() {
      try {
        this.salvando = true;

        let movimento = {
          id: this.movimento.id,
          produtos: this.produtos,
        }

        this.$store.dispatch('movimentoestoque/transferir', movimento);

        this.$eventbus.notificar("Transferência concluída com sucesso.");
        this.$router.push({ name: "EstoqueLista" });
      } catch (error) {
        this.$eventbus.erro(
          "Não foi possível transferir este movimento. Verifique os dados do pedido e tente novamente.",
          error
        );
      } finally {
        this.salvando = false;
      }
    },

    async buscarProdutoPorReferencia() {
      if (!this.produto.referencia) {
        this.buscarProduto();
        return;
      }

      try {
        this.buscando = true;
        let produto = await this.$store.dispatch(
          "produtos/buscarProdutoPorReferencia",
          this.produto.referencia
        );
        if (produto) {
          // if (produto.lotes > 1) {
          //   this.$refs.buscaproduto.busca = this.produto.referencia;
          //   this.$refs.buscaproduto.buscar();
          //   this.$refs.buscaproduto.abrir();
          // }
          this.selecionarProduto(produto);
        }
      } catch (error) {
        this.$eventbus.erro("Produto não encontrado.", error);
        this.setFocus("referencia");
        this.selectText("referencia");
      } finally {
        this.buscando = false;
      }
    },

    async buscarProdutoPorDescricao() {
      this.exibirMensagem = false;
      this.buscando = true;
      this.produtosBusca = await this.$store.dispatch(
        "produtos/buscarProdutoPorDescricao",
        this.buscarproduto
      );
      if (this.produtosBusca.length == 0) {
        this.exibirMensagem = true;
      }
      this.buscando = false;
    },

    buscarProduto() {
      this.$refs.buscaproduto.abrir();
      // this.drawerProdutos = true
      // this.setFocus('buscarproduto');
      // this.$store.commit('TOGGLE_RIGHT_DRAWER')
    },

    selecionarProduto(produto) {
      this.produto.produto_id = produto.id;
      this.produto.referencia = produto.referencia;
      this.produto.descricao = produto.descricao;
      this.produto.valor = produto.valor_custo;
      this.produto.quantidade = 1;
      this.produto.unidade = produto.unidade;
      this.produto.estoque = produto.estoque;
      this.calcularSubTotal();

      this.drawerProdutos = false;
      this.setFocus("quantidade");
      this.hidedetails = false;
    },

    adicionarProduto(produto = null) {
      console.log("Passei por aqui!");
      if (!!produto) {
        this.produto = produto;
      }
      
      produto = this.clone(this.produto);
      produto.valor = produto.valor_custo;
      produto.subtotal = produto.quantidade * produto.valor_custo;
      delete produto.estoque;
      this.movimento.produtos.push(produto);
      // this.calcularTotais();
      this.limparForm();
      this.$refs.referencia.focus();
    },

    calcularSubTotal() {
      this.produto.subtotal = this.trunc(Number(this.produto.quantidade) * Number(this.produto.valor_custo));
    },

    calcularTotais() {
      this.movimento.itens = this.movimento.produtos.length;
      this.movimento.quantidade_total = this.movimento.produtos.reduce((soma, produto) => soma + Number(produto.quantidade), 0);
      this.movimento.valor_total = this.trunc(this.movimento.produtos.reduce((soma, produto) => soma + produto.subtotal, 0));
    },

    async excluirProduto(produto) {
      let response = await this.$refs.dialogoRemoverItem.abrir();
      if (response == false) {
        return;
      }

      let index = this.movimento.produtos.findIndex((p) => p == produto);
      this.movimento.produtos.splice(index, 1);
      this.$refs.dialogoRemoverItem.fechar();

      if (!this.isPedidoCompra) {
        this.$refs.adicionarProduto.focus();
      }

      // this.calcularTotais();
    },

    editarQuantidade(produto) {
      console.log(produto);
    },

    onKeyUpEscAdicionarProduto() {
      if (this.exibindoEntradas) {
        this.exibindoEntradas = false;
        this.setFocus("quantidade");
      } else {
        this.limparForm();
        this.setFocus("referencia");
      }
    },

    onMovimentoChange(movimento) {
      if (movimento == "Entrada") {
        this.movimento.loja_id_destino = "";
      }
    },

    onKeyUpEnterQuantidade() {
      if (!this.isEntrada) {
        this.adicionarProduto();
      } else {
        this.$refs.valor.focus();
      }
    },

    limparForm() {
      this.produto = {
        referencia: null,
        descricao: null,
        quantidade: 0,
        unidade: null,
        valor: 0,
        subtotal: 0,
      };
      this.hidedetails = true;
    },

    exibirEntradas(produto) {
      this.$store.commit("produtos/SET_PRODUTO", produto);
      this.$refs.dialogoExibirEntradas.abrir();
      this.exibindoEntradas = true;
    },

    abrirPedidosCompra() {
      this.$refs.dialogoPedidosCompra.abrir(this.movimento.fornecedor_id);
    },

    carregarPedidoCompra(pedido) {
      this.movimento.fornecedor_id = pedido.fornecedor_id;
      this.movimento.movimento = "Entrada";
      this.movimento.pedidocompra_id = pedido.id;
      this.movimento.produtos = [];
      // this.movimento.itens = pedido.itens.length;
      // this.movimento.quantidade_total = pedido.itens.reduce((soma, item) => soma + Number(item.quantidade), 0);
      pedido.itens_selecionados.forEach((item) => {
        this.movimento.produtos.push({
          produto_id: item.produto_id,
          referencia: item.referencia,
          descricao: item.produto.descricao,
          quantidade: item.quantidade - item.quantidade_entregue,
          unidade: item.unidade,
          valor_custo: item.produto.valor_custo,
          valor: item.produto.valor_custo,
          subtotal: item.produto.valor_custo * item.quantidade,
        });
      });
    },

    gerarParcelas() {

      if (this.movimento.valor_total > 0 && this.movimento.fornecedor_id) {
        this.$refs.tabContasPagar.gerarParcelas({
          vencimento: this.$dayjs().add(1, 'day').format('YYYY-MM-DD'),
          forma_pagamento: "Depósito Bancário",
          parcelas: 1
        });
      }

    }
  },

  watch: {
    "movimento.produtos": {
      deep: true,
      handler(newValue, oldValue) {
        this.calcularTotais();
        console.log(new Date());
      }
    }
  },
};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */

.trasparente >>> .v-input__slot {
  background: none;
}
</style>
